<div id="login" class="flex flex-col"
     cdkScrollbar  [cdkScrollbarOptions]="{suppressScrollX: false, suppressScrollY: false, wheelPropagation: false, updateOnRouteChange: true}">

    <div class="loading-config" *ngIf="(loadingConfig$ | async)">
        <mat-spinner color="primary" diameter="36"></mat-spinner>
    </div>

    <div class="login-form-wrapper flex flex-col justify-center items-center content-center" *ngIf="!(loadingConfig$ | async) && config && config.error">
        <div class="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
            <div class="logo">
                <img [src]="config.logo">
            </div>

            <div class="subtitle">Sistema encontra-se indisponível no momento.<br/>Tente novamente mais tarde.</div>
            <div class="separator">
                <span class="text">OU</span>
            </div>
            <div class="register mb-2 flex flex-col justify-center items-center content-center">
                <a class="link" [routerLink]="'/auth/login'" (click)="reloadConfig()">Recarregar</a>
            </div>
        </div>
    </div>

    <div class="login-gov-br" *ngIf="!!config && this.routerState.queryParams['code']">
        <div class="gov-br-wrapper" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
            <div class="logo">
                <img [src]="config.logo">

            </div>

            <div class="subtitle" *ngIf="this.routerState.queryParams['code'] &&
                    !this.routerState.queryParams['state'] ">
                Realizando o login através do <strong style="color: #1351b4">gov.br</strong>
            </div>
            <div class="subtitle" *ngIf="this.routerState.queryParams['state'] &&
                    this.routerState.queryParams['code']">
                Efetuando assinatura dos documentos, por favor aguarde...
            </div>
            <div  *ngIf="this.routerState.queryParams['error']" class="title">
                {{this.routerState.queryParams['error']}}
            </div>
            <div class="loading-gov-br">
                <mat-icon *ngIf="this.routerState.queryParams['state'] && this.routerState.queryParams['code'] "
                          class="h-52 text-52 mb-3 leading-none select-processo-icon hint-text"
                        [@animate]="{value:'*',params:{delay:'300ms',scale:'0.2'}}">lock
                </mat-icon>
                <mat-icon  *ngIf="this.routerState.queryParams['error']" class="h-52 text-52 mb-3 text-red leading-none select-processo-icon hint-text"
                        [@animate]="{value:'*',params:{delay:'300ms',scale:'0.2'}}">block
                </mat-icon>
                <mat-spinner color="primary" *ngIf="!this.routerState.queryParams['error']"  color="primary" diameter="36"></mat-spinner>
            </div>
        </div>
    </div>

    <cdk-login-form *ngIf="!this.routerState.queryParams['code'] && !this.routerState.queryParams['error']"
                    (save)="this.onSubmit($event)"
                    [config]="config"
                    [version]="version"
                    [errorMessage]="errorMessage$ | async"
                    [loading]="loading$ | async"
                    [loadingConfig]="loadingConfig$ | async"
                    [redirectUri]="routerState.queryParams['returnUrl']"></cdk-login-form>
</div>
